import React from 'react';
import { Form } from 'react-bootstrap';

const FormCad = ({ handleSubmit, schema, tipo_user, setTipoUser, errors }) => {
  const handleChange = event => {
    const { name, value, files } = event.target;
    setTipoUser({
      ...tipo_user,
      [name]: files ? files[0] : value,
    });
  };

  return (
    <Form
      id="form_tipo_user"
      onSubmit={handleSubmit}
      schema={schema}
    >
      <div className="form-group">
        <label htmlFor="nome"> Nome </label>
        <Form.Control
          id="nome"
          isInvalid={!!errors.nome}
          name="nome"
          onChange={handleChange}
          placeholder="Nome do Grupo de usuário"
          type="text"
          value={tipo_user.nome || ''}
        />
        <Form.Control.Feedback type="invalid">
          {errors.nome}
        </Form.Control.Feedback>
      </div>
    </Form>
  );
};

export default FormCad;
